export interface INDISpecial {
  id: number;
  sku: string;
  creationDate?: string;
  creationBy: string;
  supplier: string;
  description: string;
  class2: string;
  supplierSKU: string;
  indiSupplierName?: string;
  purchasePrice: number;
  supplierPrice: number;
  salesPrice: number;
  margin?: number;
  orderUnit: number;
  deliveryDays: number;
}

export const EmptyINDISpecial = (): INDISpecial => ({
  id: 1,
  sku: '',
  creationBy: '',
  supplier: 'SUPPLIER_INDI',
  description: '',
  class2: '',
  supplierSKU: '',
  indiSupplierName: '',
  purchasePrice: null as unknown as number,
  supplierPrice: null as unknown as number,
  salesPrice: null as unknown as number,
  orderUnit: 1,
  deliveryDays: 0,
});
